export function groupAndOrderBySection(items: Item[], sections: string[]): GroupedItem[] {
    const groupedMap = new Map<string, Item[]>();

    sections.forEach(section => {
        groupedMap.set(section, []);
    });

    // sort by Section
    items.forEach(item => {
        if (!groupedMap.has(item.Section)) {
            groupedMap.set(item.Section, []);
        }
        groupedMap.get(item.Section)!.push(item);
    });

    //Map into Array with format of GroupedItem
    return Array.from(groupedMap.entries()).map(([section, children]) => ({
        Section: section,
        children
    }));
}

export function getOrderedSectionFromTableInfo(info: any): string[] {
    const options = info.columns?.find((col: any) => col.title == "Section")?.colOptions?.options;
    let orderedColums: string[] = [];
    options.forEach((option: {title: string}) => {
        orderedColums.push(option.title);
    })
    return orderedColums;
}